Registrera inbetalningar
<form [formGroup]="feeform">
  <div class="row">
    <div class="form-group col-md-2">
      <label for="registerDate">
        Datum
      </label>
      <input type="text" class="form-control form-control-sm" id="registerDate" formControlName="registerDate" mask="0000-00-00"  required>
    </div>
    <div class="form-group col-md-2">
      <label for="amount">
        Belopp
      </label>
      <input type="text" class="form-control form-control-sm" id="amount" formControlName="amount" required>
    </div>
    <div class="form-group col-md-4">
      <label>&nbsp;</label>
      <button class="btn border col-md-12" id="registerbtn" [disabled]="!feeform.valid || newpayments.length === 0" (click)="registerPayments()">Registrera inbetalningar</button>
    </div>
  </div>
</form>
<div class="row" style="background-color: #F0F0F0;">
  <div class="col-md-4">Medlem</div>
  <div class="col-md-2">Datum</div>
  <div class="col-md-2">Betalningar</div>
  <div class="col-md-1">Belopp</div>
  <div class="col-md-1">Totalt</div>
  <div class="col-md-1"></div>
</div>
<div *ngFor="let mp of memberpayments; let i = index" style="border-bottom:1px solid #F0F0F0;">
  <div class="row" style="margin-top:5px;">
    <div class="col-md-4">{{mp.givenName}} {{mp.familyName}} ({{mp.memberId}})</div>
    <div class="col-md-2"></div>
    <div class="col-md-2"></div>
    <div class="col-md-1"></div>
    <div class="col-md-1"></div>
    <div class="col-md-1"></div>
    <mat-checkbox id={{mp.memberId}} [value]="mp.memberId" (change)="viewMemberId($event)"></mat-checkbox>
  </div>
  <div *ngIf="mp.payments.length > 0" class="col-md-12">
    <div *ngFor="let p of mp.payments">
      <div class="row">
        <div class="col-md-4"></div>
        <div class="col-md-2">{{p.paidDate | date: 'yyyy-MM-dd'}}</div>
        <div class="col-md-2">{{p.paidAmount}}</div>
        <div class="col-md-1">{{p.totalPaidAmount}}</div>
        <div class="col-md-1">{{p.totalAmountToPay}}</div>
        <div *ngIf="p.isFullyPaid" class="col-md-1">
          <i class="fa fa-check" aria-hidden="true" style="color:green;"></i>
        </div>
        <div *ngIf="!p.isFullyPaid" class="col-md-1">
          <i class="fa fa-times" aria-hidden="true" style="color:red;"></i>
        </div>
      </div>
    </div>
  </div>
</div>